// Mock Materials Data - İNSANET
// İnşaat malzeme takibi verileri

export const materialCategories = [
    { key: 'beton', label: 'Beton', color: 'bg-neutral-600' },
    { key: 'demir', label: 'Demir', color: 'bg-info' },
    { key: 'boya', label: 'Boya', color: 'bg-warning' },
    { key: 'kapi-pencere', label: 'Kapı/Pencere', color: 'bg-tertiary' },
    { key: 'seramik', label: 'Seramik/Fayans', color: 'bg-secondary' },
    { key: 'elektrik', label: 'Elektrik', color: 'bg-error' },
    { key: 'tesisat', label: 'Su Tesisatı', color: 'bg-info' },
    { key: 'dogalgaz', label: 'Doğalgaz', color: 'bg-warning' },
    { key: 'fore-kazik', label: 'Fore Kazık', color: 'bg-primary' },
    { key: 'izolasyon', label: 'İzolasyon', color: 'bg-success' },
    { key: 'alci-siva', label: 'Alçı/Sıva', color: 'bg-neutral-400' },
    { key: 'cati', label: 'Çatı/Kiremit', color: 'bg-secondary' },
];

// Maliyet Tahmini için kategoriler (CostEstimation sayfası)
export const MATERIAL_CATEGORIES = {
    structural: { label: 'Yapısal', color: 'primary' },
    finishing: { label: 'İç Mekan', color: 'secondary' },
    electrical: { label: 'Elektrik', color: 'warning' },
    plumbing: { label: 'Tesisat', color: 'info' },
    exterior: { label: 'Dış Cephe', color: 'tertiary' },
    other: { label: 'Diğer', color: 'neutral' },
};

// Birim tipleri
export const UNIT_TYPES = {
    adet: 'Adet',
    kg: 'Kilogram',
    ton: 'Ton',
    m: 'Metre',
    m2: 'm²',
    m3: 'm³',
    lt: 'Litre',
    paket: 'Paket',
    torba: 'Torba',
    set: 'Set',
    teneke: 'Teneke',
};


// Her malzeme için teslimat planı - ÖDEMELİ VE İLERLEMELİ
export const mockMaterials = {
    beton: {
        name: 'Beton',
        unit: 'm³',
        totalRequired: 2500,
        totalDelivered: 1800,
        progressPercent: 72,
        deliveries: [
            { id: 'bet-1', date: '2025-10-15', quantity: 500, status: 'delivered', notes: '1. Parti - Temel betonu' },
            { id: 'bet-2', date: '2025-11-10', quantity: 450, status: 'delivered', notes: '2. Parti - Bodrum kat' },
            { id: 'bet-3', date: '2025-12-05', quantity: 450, status: 'delivered', notes: '3. Parti - Zemin kat' },
            { id: 'bet-4', date: '2026-01-05', quantity: 400, status: 'delivered', notes: '4. Parti - 1. kat' },
            { id: 'bet-5', date: '2026-02-15', quantity: 350, status: 'scheduled', notes: '5. Parti - 2. kat' },
            { id: 'bet-6', date: '2026-03-20', quantity: 350, status: 'scheduled', notes: '6. Parti - 3. kat' },
        ],
        iscilik: {
            contractor: 'Özkan Beton Ltd.',
            startDate: '2025-10-15',
            endDate: '2026-04-30',
            status: 'ongoing',
            progressPercent: 65,
            progressNotes: [
                { date: '2025-10-20', note: 'Temel betonu tamamlandı', percent: 20 },
                { date: '2025-11-15', note: 'Bodrum kat tamamlandı', percent: 35 },
                { date: '2025-12-10', note: 'Zemin kat tamamlandı', percent: 50 },
                { date: '2026-01-10', note: '1. kat tamamlandı', percent: 65 },
            ],
        },
        payment: {
            totalAgreed: 2500000,
            totalPaid: 1800000,
            remaining: 700000,
            paymentPlan: [
                { id: 'pay-bet-1', date: '2025-10-20', amount: 500000, status: 'paid', note: 'Başlangıç ödemesi' },
                { id: 'pay-bet-2', date: '2025-11-15', amount: 450000, status: 'paid', note: '2. parti sonrası' },
                { id: 'pay-bet-3', date: '2025-12-15', amount: 450000, status: 'paid', note: '3. parti sonrası' },
                { id: 'pay-bet-4', date: '2026-01-15', amount: 400000, status: 'paid', note: '4. parti sonrası' },
                { id: 'pay-bet-5', date: '2026-02-20', amount: 350000, status: 'pending', note: '5. parti sonrası' },
                { id: 'pay-bet-6', date: '2026-03-25', amount: 350000, status: 'pending', note: 'Son ödeme' },
            ],
        },
    },
    demir: {
        name: 'Demir',
        unit: 'ton',
        totalRequired: 180,
        totalDelivered: 120,
        progressPercent: 67,
        deliveries: [
            { id: 'dem-1', date: '2025-10-10', quantity: 40, status: 'delivered', notes: 'Temel demiri' },
            { id: 'dem-2', date: '2025-11-05', quantity: 40, status: 'delivered', notes: 'Kolon-kiriş demiri' },
            { id: 'dem-3', date: '2025-12-20', quantity: 40, status: 'delivered', notes: 'Döşeme demiri' },
            { id: 'dem-4', date: '2026-02-10', quantity: 30, status: 'scheduled', notes: 'Üst kat demiri' },
            { id: 'dem-5', date: '2026-03-15', quantity: 30, status: 'scheduled', notes: 'Son parti' },
        ],
        iscilik: {
            contractor: 'Yılmaz Demir İşleri',
            startDate: '2025-10-12',
            endDate: '2026-04-15',
            status: 'ongoing',
            progressPercent: 60,
            progressNotes: [
                { date: '2025-10-25', note: 'Temel demiri döşendi', percent: 25 },
                { date: '2025-11-20', note: 'Kolon demiri tamamlandı', percent: 45 },
                { date: '2025-12-30', note: 'Zemin kat döşeme demiri', percent: 60 },
            ],
        },
        payment: {
            totalAgreed: 1800000,
            totalPaid: 1200000,
            remaining: 600000,
            paymentPlan: [
                { id: 'pay-dem-1', date: '2025-10-15', amount: 400000, status: 'paid', note: 'Başlangıç ödemesi' },
                { id: 'pay-dem-2', date: '2025-11-10', amount: 400000, status: 'paid', note: '2. parti' },
                { id: 'pay-dem-3', date: '2025-12-25', amount: 400000, status: 'paid', note: '3. parti' },
                { id: 'pay-dem-4', date: '2026-02-15', amount: 300000, status: 'pending', note: '4. parti' },
                { id: 'pay-dem-5', date: '2026-03-20', amount: 300000, status: 'pending', note: 'Son ödeme' },
            ],
        },
    },
    boya: {
        name: 'Boya',
        unit: 'teneke',
        totalRequired: 300,
        totalDelivered: 0,
        progressPercent: 0,
        deliveries: [
            { id: 'boy-1', date: '2026-05-01', quantity: 100, status: 'scheduled', notes: 'İç cephe boyası - 1' },
            { id: 'boy-2', date: '2026-06-01', quantity: 100, status: 'scheduled', notes: 'İç cephe boyası - 2' },
            { id: 'boy-3', date: '2026-07-01', quantity: 100, status: 'scheduled', notes: 'Dış cephe boyası' },
        ],
        iscilik: {
            contractor: 'Renkli Dünyalar Boya',
            startDate: '2026-05-05',
            endDate: '2026-08-15',
            status: 'pending',
            progressPercent: 0,
            progressNotes: [],
        },
        payment: {
            totalAgreed: 450000,
            totalPaid: 0,
            remaining: 450000,
            paymentPlan: [
                { id: 'pay-boy-1', date: '2026-05-10', amount: 150000, status: 'pending', note: 'Başlangıç ödemesi' },
                { id: 'pay-boy-2', date: '2026-06-10', amount: 150000, status: 'pending', note: 'Ara ödeme' },
                { id: 'pay-boy-3', date: '2026-07-10', amount: 150000, status: 'pending', note: 'Son ödeme' },
            ],
        },
    },
    'kapi-pencere': {
        name: 'Kapı/Pencere',
        unit: 'adet',
        totalRequired: 180,
        totalDelivered: 0,
        progressPercent: 0,
        deliveries: [
            { id: 'kp-1', date: '2026-04-15', quantity: 60, status: 'scheduled', notes: 'A Blok pencereleri' },
            { id: 'kp-2', date: '2026-04-25', quantity: 60, status: 'scheduled', notes: 'B Blok pencereleri' },
            { id: 'kp-3', date: '2026-05-05', quantity: 60, status: 'scheduled', notes: 'C Blok pencereleri' },
        ],
        iscilik: {
            contractor: 'Pimapen Plus',
            startDate: '2026-04-20',
            endDate: '2026-06-15',
            status: 'pending',
            progressPercent: 0,
            progressNotes: [],
        },
        payment: {
            totalAgreed: 900000,
            totalPaid: 0,
            remaining: 900000,
            paymentPlan: [
                { id: 'pay-kp-1', date: '2026-04-20', amount: 300000, status: 'pending', note: 'Sipariş ödemesi' },
                { id: 'pay-kp-2', date: '2026-05-01', amount: 300000, status: 'pending', note: 'Montaj başlangıcı' },
                { id: 'pay-kp-3', date: '2026-06-01', amount: 300000, status: 'pending', note: 'Montaj tamamlanma' },
            ],
        },
    },
    seramik: {
        name: 'Seramik/Fayans',
        unit: 'm²',
        totalRequired: 4500,
        totalDelivered: 0,
        progressPercent: 0,
        deliveries: [
            { id: 'ser-1', date: '2026-03-01', quantity: 1500, status: 'scheduled', notes: 'Banyo seramikleri' },
            { id: 'ser-2', date: '2026-03-15', quantity: 1500, status: 'scheduled', notes: 'Mutfak seramikleri' },
            { id: 'ser-3', date: '2026-04-01', quantity: 1500, status: 'scheduled', notes: 'Balkon ve genel alan' },
        ],
        iscilik: {
            contractor: 'Usta Seramik',
            startDate: '2026-03-05',
            endDate: '2026-05-30',
            status: 'pending',
            progressPercent: 0,
            progressNotes: [],
        },
        payment: {
            totalAgreed: 675000,
            totalPaid: 0,
            remaining: 675000,
            paymentPlan: [
                { id: 'pay-ser-1', date: '2026-03-10', amount: 225000, status: 'pending', note: 'Malzeme ödemesi' },
                { id: 'pay-ser-2', date: '2026-04-01', amount: 225000, status: 'pending', note: 'İşçilik 1' },
                { id: 'pay-ser-3', date: '2026-05-01', amount: 225000, status: 'pending', note: 'İşçilik 2' },
            ],
        },
    },
    elektrik: {
        name: 'Elektrik Malzemesi',
        unit: 'set',
        totalRequired: 48,
        totalDelivered: 16,
        progressPercent: 33,
        deliveries: [
            { id: 'elk-1', date: '2025-12-15', quantity: 16, status: 'delivered', notes: 'Kablo ve boru' },
            { id: 'elk-2', date: '2026-04-01', quantity: 16, status: 'scheduled', notes: 'Priz ve anahtar' },
            { id: 'elk-3', date: '2026-05-15', quantity: 16, status: 'scheduled', notes: 'Aydınlatma' },
        ],
        iscilik: {
            contractor: 'Elektrik Ustası Mehmet',
            startDate: '2025-12-20',
            endDate: '2026-06-30',
            status: 'ongoing',
            progressPercent: 30,
            progressNotes: [
                { date: '2026-01-05', note: 'Kaba elektrik tesisatı tamamlandı', percent: 30 },
            ],
        },
        payment: {
            totalAgreed: 480000,
            totalPaid: 160000,
            remaining: 320000,
            paymentPlan: [
                { id: 'pay-elk-1', date: '2025-12-20', amount: 160000, status: 'paid', note: 'Başlangıç' },
                { id: 'pay-elk-2', date: '2026-04-05', amount: 160000, status: 'pending', note: 'Ara ödeme' },
                { id: 'pay-elk-3', date: '2026-05-20', amount: 160000, status: 'pending', note: 'Son ödeme' },
            ],
        },
    },
    tesisat: {
        name: 'Su Tesisatı',
        unit: 'set',
        totalRequired: 48,
        totalDelivered: 24,
        progressPercent: 50,
        deliveries: [
            { id: 'tes-1', date: '2025-11-20', quantity: 24, status: 'delivered', notes: 'Boru ve bağlantılar' },
            { id: 'tes-2', date: '2026-04-15', quantity: 24, status: 'scheduled', notes: 'Vitrifiye ve armatür' },
        ],
        iscilik: {
            contractor: 'Su Tesisatçısı Ali',
            startDate: '2025-11-25',
            endDate: '2026-05-30',
            status: 'ongoing',
            progressPercent: 45,
            progressNotes: [
                { date: '2025-12-10', note: 'Kaba tesisat döşendi', percent: 25 },
                { date: '2026-01-05', note: 'Pis su tesisatı tamamlandı', percent: 45 },
            ],
        },
        payment: {
            totalAgreed: 360000,
            totalPaid: 180000,
            remaining: 180000,
            paymentPlan: [
                { id: 'pay-tes-1', date: '2025-11-25', amount: 180000, status: 'paid', note: 'Başlangıç' },
                { id: 'pay-tes-2', date: '2026-04-20', amount: 180000, status: 'pending', note: 'Tamamlanma' },
            ],
        },
    },
    dogalgaz: {
        name: 'Doğalgaz Tesisatı',
        unit: 'set',
        totalRequired: 48,
        totalDelivered: 0,
        progressPercent: 0,
        deliveries: [
            { id: 'gaz-1', date: '2026-05-01', quantity: 48, status: 'scheduled', notes: 'Kombi ve boru hattı' },
        ],
        iscilik: {
            contractor: 'Gaz Tesisatçısı Hasan',
            startDate: '2026-05-05',
            endDate: '2026-07-15',
            status: 'pending',
            progressPercent: 0,
            progressNotes: [],
        },
        payment: {
            totalAgreed: 720000,
            totalPaid: 0,
            remaining: 720000,
            paymentPlan: [
                { id: 'pay-gaz-1', date: '2026-05-10', amount: 360000, status: 'pending', note: 'Başlangıç' },
                { id: 'pay-gaz-2', date: '2026-06-15', amount: 360000, status: 'pending', note: 'Tamamlanma' },
            ],
        },
    },
    'fore-kazik': {
        name: 'Fore Kazık',
        unit: 'adet',
        totalRequired: 120,
        totalDelivered: 120,
        progressPercent: 100,
        deliveries: [
            { id: 'fk-1', date: '2025-09-01', quantity: 40, status: 'delivered', notes: 'A Blok temeli' },
            { id: 'fk-2', date: '2025-09-15', quantity: 40, status: 'delivered', notes: 'B Blok temeli' },
            { id: 'fk-3', date: '2025-10-01', quantity: 40, status: 'delivered', notes: 'C Blok temeli' },
        ],
        iscilik: {
            contractor: 'Temel İnşaat A.Ş.',
            startDate: '2025-09-01',
            endDate: '2025-10-30',
            status: 'completed',
            progressPercent: 100,
            progressNotes: [
                { date: '2025-09-10', note: 'A Blok kazıkları tamamlandı', percent: 33 },
                { date: '2025-09-25', note: 'B Blok kazıkları tamamlandı', percent: 66 },
                { date: '2025-10-10', note: 'C Blok kazıkları tamamlandı', percent: 100 },
            ],
        },
        payment: {
            totalAgreed: 1200000,
            totalPaid: 1200000,
            remaining: 0,
            paymentPlan: [
                { id: 'pay-fk-1', date: '2025-09-05', amount: 400000, status: 'paid', note: 'A Blok' },
                { id: 'pay-fk-2', date: '2025-09-20', amount: 400000, status: 'paid', note: 'B Blok' },
                { id: 'pay-fk-3', date: '2025-10-15', amount: 400000, status: 'paid', note: 'C Blok' },
            ],
        },
    },
    izolasyon: {
        name: 'İzolasyon',
        unit: 'm²',
        totalRequired: 3000,
        totalDelivered: 1000,
        progressPercent: 33,
        deliveries: [
            { id: 'izo-1', date: '2025-12-01', quantity: 1000, status: 'delivered', notes: 'Temel izolasyonu' },
            { id: 'izo-2', date: '2026-06-01', quantity: 1000, status: 'scheduled', notes: 'Dış cephe izolasyonu' },
            { id: 'izo-3', date: '2026-07-01', quantity: 1000, status: 'scheduled', notes: 'Çatı izolasyonu' },
        ],
        iscilik: {
            contractor: 'İzolasyon Ustaları',
            startDate: '2025-12-05',
            endDate: '2026-08-15',
            status: 'ongoing',
            progressPercent: 33,
            progressNotes: [
                { date: '2025-12-20', note: 'Temel izolasyonu tamamlandı', percent: 33 },
            ],
        },
        payment: {
            totalAgreed: 450000,
            totalPaid: 150000,
            remaining: 300000,
            paymentPlan: [
                { id: 'pay-izo-1', date: '2025-12-10', amount: 150000, status: 'paid', note: 'Temel' },
                { id: 'pay-izo-2', date: '2026-06-10', amount: 150000, status: 'pending', note: 'Cephe' },
                { id: 'pay-izo-3', date: '2026-07-10', amount: 150000, status: 'pending', note: 'Çatı' },
            ],
        },
    },
    'alci-siva': {
        name: 'Alçı/Sıva',
        unit: 'torba',
        totalRequired: 500,
        totalDelivered: 0,
        progressPercent: 0,
        deliveries: [
            { id: 'alc-1', date: '2026-04-01', quantity: 250, status: 'scheduled', notes: 'İç sıva malzemesi' },
            { id: 'alc-2', date: '2026-05-01', quantity: 250, status: 'scheduled', notes: 'Alçı ve son kat' },
        ],
        iscilik: {
            contractor: 'Sıvacı Ahmet',
            startDate: '2026-04-05',
            endDate: '2026-06-30',
            status: 'pending',
            progressPercent: 0,
            progressNotes: [],
        },
        payment: {
            totalAgreed: 375000,
            totalPaid: 0,
            remaining: 375000,
            paymentPlan: [
                { id: 'pay-alc-1', date: '2026-04-10', amount: 125000, status: 'pending', note: 'Başlangıç' },
                { id: 'pay-alc-2', date: '2026-05-10', amount: 125000, status: 'pending', note: 'Ara ödeme' },
                { id: 'pay-alc-3', date: '2026-06-10', amount: 125000, status: 'pending', note: 'Son ödeme' },
            ],
        },
    },
    cati: {
        name: 'Çatı/Kiremit',
        unit: 'adet',
        totalRequired: 5000,
        totalDelivered: 0,
        progressPercent: 0,
        deliveries: [
            { id: 'cat-1', date: '2026-07-01', quantity: 5000, status: 'scheduled', notes: 'Kiremit ve çatı malzemesi' },
        ],
        iscilik: {
            contractor: 'Çatıcı Usta',
            startDate: '2026-07-05',
            endDate: '2026-08-30',
            status: 'pending',
            progressPercent: 0,
            progressNotes: [],
        },
        payment: {
            totalAgreed: 600000,
            totalPaid: 0,
            remaining: 600000,
            paymentPlan: [
                { id: 'pay-cat-1', date: '2026-07-10', amount: 300000, status: 'pending', note: 'Malzeme' },
                { id: 'pay-cat-2', date: '2026-08-15', amount: 300000, status: 'pending', note: 'İşçilik' },
            ],
        },
    },
};

// Yardımcı fonksiyonlar
export const getMaterialByKey = (key) => {
    return mockMaterials[key] || null;
};

export const getMaterialStats = (material) => {
    if (!material) return { progressPercent: 0 };
    const progressPercent = Math.round((material.totalDelivered / material.totalRequired) * 100);
    return { progressPercent };
};

export const getAllMaterials = () => {
    return Object.entries(mockMaterials).map(([key, value]) => ({
        key,
        ...value,
    }));
};

export const addMaterialCategory = (category) => {
    materialCategories.push(category);
};

// Maliyet Tahmini için malzemeler (farklı yapı)
export const costMaterials = [
    // ─── YAPISAL (structural) ── constructionId: 1 ─────────────
    { id: 'cm-1', constructionId: 1, name: 'Hazır Beton C30', category: 'structural', unitType: 'm3', unitPrice: 1500, estimatedQuantity: 2500, actualQuantity: 1800, lastUpdated: '2026-01-05', notes: 'Temel ve karkas için' },
    { id: 'cm-2', constructionId: 1, name: 'Nervürlü Demir Φ12-32', category: 'structural', unitType: 'ton', unitPrice: 15000, estimatedQuantity: 180, actualQuantity: 120, lastUpdated: '2025-12-20', notes: 'Kolon, kiriş, döşeme' },
    { id: 'cm-3', constructionId: 1, name: 'Tuğla 19x19', category: 'structural', unitType: 'adet', unitPrice: 4, estimatedQuantity: 85000, actualQuantity: 52000, lastUpdated: '2026-01-10', notes: 'Duvar örme (3 blok)' },
    { id: 'cm-4', constructionId: 1, name: 'Kalıp Tahtası', category: 'structural', unitType: 'm2', unitPrice: 120, estimatedQuantity: 6000, actualQuantity: 4200, lastUpdated: '2026-01-08', notes: 'Plywood 18mm' },
    { id: 'cm-5', constructionId: 1, name: 'Çimento (Torba)', category: 'structural', unitType: 'torba', unitPrice: 85, estimatedQuantity: 3000, actualQuantity: 1800, lastUpdated: '2025-12-28', notes: 'CEM I 42.5R' },
    { id: 'cm-6', constructionId: 1, name: 'Kum & Çakıl', category: 'structural', unitType: 'ton', unitPrice: 350, estimatedQuantity: 800, actualQuantity: 500, lastUpdated: '2026-01-03', notes: 'Elenmiş dere kumu' },
    { id: 'cm-30', constructionId: 1, name: 'Fore Kazık', category: 'structural', unitType: 'adet', unitPrice: 10000, estimatedQuantity: 120, actualQuantity: 120, lastUpdated: '2025-09-20', notes: 'Tamamlandı' },

    // ─── İÇ MEKAN (finishing) ─────────────
    { id: 'cm-7', constructionId: 1, name: 'Seramik 60x60', category: 'finishing', unitType: 'm2', unitPrice: 150, estimatedQuantity: 4500, actualQuantity: null, lastUpdated: '2025-11-15', notes: 'Yerli üretim 1. kalite' },
    { id: 'cm-8', constructionId: 1, name: 'Banyo Armatür Seti', category: 'finishing', unitType: 'set', unitPrice: 4500, estimatedQuantity: 48, actualQuantity: null, lastUpdated: '2025-12-01', notes: 'Lavabo+WC+Duş+Batarya' },
    { id: 'cm-9', constructionId: 1, name: 'Mutfak Dolabı', category: 'finishing', unitType: 'set', unitPrice: 18000, estimatedQuantity: 48, actualQuantity: null, lastUpdated: '2025-11-25', notes: 'MDF lake, tezgah dahil' },
    { id: 'cm-10', constructionId: 1, name: 'Laminat Parke', category: 'finishing', unitType: 'm2', unitPrice: 120, estimatedQuantity: 3200, actualQuantity: null, lastUpdated: '2025-12-10', notes: 'AC4 sınıfı 8mm' },
    { id: 'cm-11', constructionId: 1, name: 'İç Kapı (Amerikan)', category: 'finishing', unitType: 'adet', unitPrice: 2800, estimatedQuantity: 192, actualQuantity: null, lastUpdated: '2026-01-02', notes: 'Kasa+kanat+kilit' },
    { id: 'cm-12', constructionId: 1, name: 'Alçıpan Asma Tavan', category: 'finishing', unitType: 'm2', unitPrice: 95, estimatedQuantity: 2400, actualQuantity: null, lastUpdated: '2025-12-18', notes: 'Profil+alçı levha' },
    { id: 'cm-31', constructionId: 1, name: 'İç Cephe Boyası', category: 'finishing', unitType: 'teneke', unitPrice: 850, estimatedQuantity: 200, actualQuantity: null, lastUpdated: '2026-01-12', notes: 'Yarı mat, beyaz + renkli' },
    { id: 'cm-32', constructionId: 1, name: 'Alçı / Sıva', category: 'finishing', unitType: 'torba', unitPrice: 60, estimatedQuantity: 1500, actualQuantity: null, lastUpdated: '2025-12-22', notes: 'İç sıva + alçı son kat' },

    // ─── ELEKTRİK (electrical) ─────────────
    { id: 'cm-13', constructionId: 1, name: 'Elektrik Tesisat Seti', category: 'electrical', unitType: 'set', unitPrice: 8000, estimatedQuantity: 48, actualQuantity: 16, lastUpdated: '2025-12-15', notes: 'Kablo+boru+priz+anahtar' },
    { id: 'cm-14', constructionId: 1, name: 'Jeneratör', category: 'electrical', unitType: 'adet', unitPrice: 180000, estimatedQuantity: 1, actualQuantity: null, lastUpdated: '2025-11-20', notes: '150 kVA dizel' },
    { id: 'cm-15', constructionId: 1, name: 'Güvenlik Kamera Seti', category: 'electrical', unitType: 'set', unitPrice: 4500, estimatedQuantity: 3, actualQuantity: null, lastUpdated: '2025-12-05', notes: 'Blok başına 8 kamera' },
    { id: 'cm-16', constructionId: 1, name: 'Asansör', category: 'electrical', unitType: 'adet', unitPrice: 320000, estimatedQuantity: 3, actualQuantity: null, lastUpdated: '2026-01-15', notes: '8 kişilik, 3 blok' },
    { id: 'cm-33', constructionId: 1, name: 'Aydınlatma Armatürleri', category: 'electrical', unitType: 'set', unitPrice: 3500, estimatedQuantity: 48, actualQuantity: null, lastUpdated: '2026-01-10', notes: 'LED downlight+spot seti' },

    // ─── TESİSAT (plumbing) ─────────────
    { id: 'cm-17', constructionId: 1, name: 'Su Tesisat Seti', category: 'plumbing', unitType: 'set', unitPrice: 6000, estimatedQuantity: 48, actualQuantity: 24, lastUpdated: '2025-11-20', notes: 'Temiz+pis su komple' },
    { id: 'cm-18', constructionId: 1, name: 'Doğalgaz Tesisatı', category: 'plumbing', unitType: 'set', unitPrice: 15000, estimatedQuantity: 48, actualQuantity: null, lastUpdated: '2025-12-25', notes: 'Kombi+boru hattı' },
    { id: 'cm-19', constructionId: 1, name: 'Yangın Tesisat Seti', category: 'plumbing', unitType: 'set', unitPrice: 25000, estimatedQuantity: 3, actualQuantity: null, lastUpdated: '2026-01-05', notes: 'Blok başına sprinkler+yangın dolabı' },
    { id: 'cm-34', constructionId: 1, name: 'Kanalizasyon Borusu', category: 'plumbing', unitType: 'm', unitPrice: 45, estimatedQuantity: 2000, actualQuantity: 1200, lastUpdated: '2025-12-15', notes: 'PVC Ø110-200mm' },

    // ─── DIŞ CEPHE (exterior) ─────────────
    { id: 'cm-20', constructionId: 1, name: 'PVC Pencere Isıcam', category: 'exterior', unitType: 'adet', unitPrice: 3500, estimatedQuantity: 180, actualQuantity: null, lastUpdated: '2025-11-01', notes: '4+16+4 ısıcam' },
    { id: 'cm-21', constructionId: 1, name: 'Dış Cephe Mantolama', category: 'exterior', unitType: 'm2', unitPrice: 250, estimatedQuantity: 4200, actualQuantity: null, lastUpdated: '2025-12-10', notes: '5cm EPS + sıva + boya' },
    { id: 'cm-22', constructionId: 1, name: 'Dış Cephe Boyası', category: 'exterior', unitType: 'teneke', unitPrice: 1200, estimatedQuantity: 80, actualQuantity: null, lastUpdated: '2025-12-15', notes: 'Silikon esaslı' },
    { id: 'cm-23', constructionId: 1, name: 'Çatı Kiremit + Aksam', category: 'exterior', unitType: 'set', unitPrice: 200000, estimatedQuantity: 3, actualQuantity: null, lastUpdated: '2026-01-08', notes: 'Blok başına çatı' },
    { id: 'cm-35', constructionId: 1, name: 'Balkon Korkuluğu', category: 'exterior', unitType: 'm', unitPrice: 350, estimatedQuantity: 600, actualQuantity: null, lastUpdated: '2026-01-14', notes: 'Alüminyum cam korkuluk' },

    // ─── DİĞER (other) ─────────────
    { id: 'cm-24', constructionId: 1, name: 'Hafriyat', category: 'other', unitType: 'm3', unitPrice: 45, estimatedQuantity: 8000, actualQuantity: 8000, lastUpdated: '2025-09-15', notes: 'Temel kazı (tamamlandı)' },
    { id: 'cm-25', constructionId: 1, name: 'Vinç Kiralama', category: 'other', unitType: 'adet', unitPrice: 85000, estimatedQuantity: 2, actualQuantity: 2, lastUpdated: '2025-10-01', notes: 'Kule vinç 12 ay' },
    { id: 'cm-26', constructionId: 1, name: 'Güvenlik Bariyeri', category: 'other', unitType: 'm', unitPrice: 80, estimatedQuantity: 500, actualQuantity: 500, lastUpdated: '2025-09-20', notes: 'Şantiye çevresi' },

    // ─── constructionId: 2 ─────────────
    { id: 'cm-27', constructionId: 2, name: 'Hazır Beton C25', category: 'structural', unitType: 'm3', unitPrice: 1400, estimatedQuantity: 1200, actualQuantity: 600, lastUpdated: '2025-12-01', notes: 'Temel için' },
    { id: 'cm-28', constructionId: 2, name: 'Tuğla 19x19', category: 'structural', unitType: 'adet', unitPrice: 4, estimatedQuantity: 50000, actualQuantity: 20000, lastUpdated: '2025-11-25', notes: 'Duvar örme' },
    { id: 'cm-29', constructionId: 2, name: 'Nervürlü Demir Φ10-25', category: 'structural', unitType: 'ton', unitPrice: 14500, estimatedQuantity: 90, actualQuantity: 45, lastUpdated: '2025-12-10', notes: 'Kolon ve döşeme' },
];

// ─── Maliyet Tahmini fonksiyonları ───────────────────────────
export const getMaterialsByConstructionId = (constructionId) => {
    if (!constructionId) return costMaterials;
    return costMaterials.filter(m => m.constructionId === constructionId);
};

// NOT: CostEstimation sayfası bu fonksiyonu kullanır (eski getMaterialCostStats)
export const getMaterialCostStats = (constructionId) => {
    const materials = getMaterialsByConstructionId(constructionId);
    const costs = materials.map(m => m.unitPrice * m.estimatedQuantity);
    const totalEstimated = costs.reduce((s, c) => s + c, 0);
    const withActual = materials.filter(m => m.actualQuantity != null);
    const totalActual = withActual.reduce((s, m) => s + (m.unitPrice * m.actualQuantity), 0);
    return {
        totalMaterials: materials.length,
        totalEstimatedCost: totalEstimated,
        totalActualCost: totalActual,
        categories: [...new Set(materials.map(m => m.category))].length,
        completedItems: materials.filter(m => m.actualQuantity != null && m.actualQuantity >= m.estimatedQuantity).length,
        inProgressItems: materials.filter(m => m.actualQuantity != null && m.actualQuantity > 0 && m.actualQuantity < m.estimatedQuantity).length,
        pendingItems: materials.filter(m => m.actualQuantity == null || m.actualQuantity === 0).length,
        budgetVariance: totalEstimated > 0 ? ((totalActual / totalEstimated) * 100).toFixed(1) : 0,
    };
};

export const calculateEstimatedCost = (material) => {
    if (!material) return 0;
    return material.unitPrice * material.estimatedQuantity;
};

export const calculateActualCost = (material) => {
    if (!material || material.actualQuantity == null) return 0;
    return material.unitPrice * material.actualQuantity;
};

export const getCostByCategory = (materials) => {
    if (!materials || !Array.isArray(materials)) {
        materials = costMaterials;
    }
    const result = {};
    materials.forEach(m => {
        if (!result[m.category]) {
            result[m.category] = 0;
        }
        result[m.category] += calculateEstimatedCost(m);
    });
    return result;
};
